import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectState } from '../../../../store/Project/ProjectTypes'

export const removeWorkingStepFromBomItem: CaseReducer<
  ProjectState,
  PayloadAction<{
    bomItemId: string
    workingStepType: WorkingStepType
  }>
> = (state, action) => {
  if (action.payload.bomItemId === state.activeProject?.id) {
    state.activeProject.workingSteps = state.activeProject.workingSteps.filter(
      (ws) => ws.primaryWorkingStep !== action.payload.workingStepType
    )
    return state
  }

  const bomItem =
    state.flatView[action.payload.bomItemId] ||
    state.treeView[action.payload.bomItemId]

  switch (bomItem?.type) {
    case 'AssemblyHeader': {
      bomItem.assembly.assemblyWorkingStepDtos =
        bomItem.assembly.assemblyWorkingStepDtos.filter(
          (ws) => ws.primaryWorkingStep !== action.payload.workingStepType
        )
      break
    }
    case 'Assembly':
    case 'Row': {
      bomItem.workingSteps = bomItem.workingSteps.filter(
        (ws) => ws.primaryWorkingStep !== action.payload.workingStepType
      )
      break
    }
  }

  return state
}
